module.exports = __webpack_public_path__ + "img/vn-flag.cb4b5666.svg";